import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { IUserMast } from "../../models/UserMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { EmptyUser } from "../userMast/EmptyUser";
import { Toast } from "primereact/toast";
import { Fetch } from "../../shared/Fetch";
import { IUsersDropdown } from "../../models/IDropdown";
import { useNavigate } from "react-router-dom";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

const schema = yup.object({
    user_Name: yup.string().required("UserName is required*").min(3),
    login_Name: yup.string().required("LoginName is required*").min(3),
    user_EmailID: yup.string().required("UserEmailID is required*").email(),
    login_Password: yup.string().required("loginPassword is required*").min(6).max(16),
});

export const UserProfile = () => {
    const toast = useRef<any>(null);
    const [sm, setSM] = useState<Array<IUsersDropdown>>([]);
    const [disabledCallerId, setDisabledCallerId] = useState(false);

    const Navigate = useNavigate();
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IUserMast>({
        resolver: yupResolver(schema),
        defaultValues: {
            ...EmptyUser,
        },
        shouldFocusError: false,
    });

    useEffect(() => {
        (async () => {
            const response = await Fetch(`User_Mast/me`, "GET", null, null, toast);
            if (response) {
                const data1: any = await response.json();
                const user = data1.user;
                const callingUser = data1.callingUser?.[0];
                reset({
                    ...user,
                    ivrUser_Name: callingUser?.ivrUser_Name || callingUser?.user_Name || "",
                });

                if (data1.disabled === true) {
                    setDisabledCallerId(true);
                }
            }
        })();
    }, []);

    const saveToDB = async (body: IUserMast) => {
        const response = await Fetch("User_Mast/password", "PUT", body, null, toast);
        if (response) {
            if (disabledCallerId) {
                toast.current.show({ severity: 'success', detail: "Password Updated Successfully", life: 3000 });
            } else {
                toast.current.show({ severity: 'success', detail: "Caller ID Updated Successfully", life: 3000 });
            }
            setTimeout(() => {
                Navigate("/");
            }, 2000);
        }
    };


    const loadUsers = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/getcalleridlinkedlist`, "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSM(data);
        }
    };

    useEffect(() => {
        // loadUsers();
    }, []);

    const onSubmit = (data: IUserMast) => {
        console.log(data.extension_ID)
        if (!disabledCallerId && data.extension_ID !==null) {
            const finalData = {
                ...data,
                extension_ID: typeof data.extension_ID === 'object'
                    ? data.extension_ID.extension_ID
                    : data.extension_ID
            };
            saveToDB(finalData);
        } else {
            saveToDB(data);

        }
        saveToDB(data);

    };

    const completeMethodSubVendor = (event: { query: string }) => {
        loadUsers(event.query);
    }

    return (
        <Card title="Update Password" style={{ width: '80vw' }}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput disabled label="Name" control={control} name="user_Name" error={errors.user_Name?.message} />
                <JVInput disabled label="Email" control={control} name="user_EmailID" error={errors.user_EmailID?.message} />
                <JVInput disabled label="LoginID" control={control} name="login_Name" error={errors.login_Name?.message} />
                <JVInput required label="Password" control={control} name="login_Password" error={errors.login_Password?.message} />
                {disabledCallerId && <JVInput label="Caller ID" control={control} name="ivrUser_Name" disabled />}
                {/* {!disabledCallerId && <JVDropdown disabled={disabledCallerId} label="Caller ID" control={control} name="extension_ID" options={sm} optionLabel="user_Name" optionValue="extension_ID" placeholder="Select CallerID" />} */}
                {/* <JVInputCheck required func={checkEmail} label="Caller ID" control={control} name="extension_ID" /> */}
                {!disabledCallerId && <JVDropdownInput label="Caller ID" completeMethod={completeMethodSubVendor} control={control} name="extension_ID" options={sm} optionLabel="user_Name" placeholder="Search " />}

                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit" />
                </div>
            </form>
            <Toast ref={toast} />
        </Card>
    );
};
